import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { useConversationListContext } from 'pages/conversations/ui/ConversationList/context'

export const CloseAction = observer(() => {
  const store = useConversationListContext()
  const {
    selectedHasOpenConversation,
    undoCloseConversations,
    reopenConversations,
    selectedCount,
  } = store

  const handleClose = async () => {
    await (selectedHasOpenConversation ? undoCloseConversations : reopenConversations)()
  }

  return (
    <IconButton
      icon={selectedHasOpenConversation ? 'check1' : 'back'}
      tooltipProps={{
        placement: 'bottom',
        label: selectedHasOpenConversation
          ? `Close conversation (${selectedCount})`
          : `Reopen conversation (${selectedCount})`,
        disableInteractive: true,
      }}
      onClick={handleClose}
      variant={'icon'}
      color='secondary'
      size={'medium'}
      ariaLabel='CloseAction_handleClose'
    />
  )
})
